import script from "./ScreenShotView.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenShotView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__